import { Component, OnInit, ViewChild, EventEmitter, Output, Inject } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { CustomerFacade } from '@ridango/components';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-add-email-modal',
    templateUrl: './add-email-modal.component.html',
    styleUrls: ['./add-email-modal.component.scss']
})
export class AddEmailModalComponent implements OnInit {
    @ViewChild('modal') modal: IonModal;
    @Output() completed = new EventEmitter<{ success: boolean; errorKey?: string }>();

    formGroup: FormGroup;

    constructor(
        @Inject('ENV') public env: Env,
        private customerFacade: CustomerFacade,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.formGroup = new FormGroup({
            email: new FormControl('', [
                Validators.required,
                Validators.email,
                Validators.pattern('^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,}$')
            ])
        });
    }

    open() {
        this.modal.present();
    }

    cancel() {
        this.modal.dismiss();
    }

    confirm() {
        this.formGroup.markAllAsTouched();
        if (this.formGroup.invalid) {
            return;
        }

        const email = this.formGroup.value.email;
        const lang = this.translate.currentLang;
        const redirectUri = `${this.env.BASE_URL}${lang}/email-confirm`;

        this.customerFacade
            .setCustomerEmail(email, lang, redirectUri)
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.modal.dismiss();
                    this.completed.emit({ success: true });
                },
                error: (err: HttpErrorResponse) => {
                    const errorKey = typeof err.error === 'string' && err.error.length ? err.error : 'INTERNAL_ERROR';
                    this.completed.emit({ success: false, errorKey: errorKey });
                }
            });
    }

    get emailInvalid() {
        const ctrl = this.formGroup.controls.email;
        return (ctrl.hasError('email') && !ctrl.hasError('required')) || ctrl.hasError('pattern');
    }
}
